import { LinearProgress, SxProps, Theme } from '@evaneos/b2b-ui';

export function AT2AnalysisLoader({ sx }: { sx?: SxProps<Theme> }) {
    return (
        <LinearProgress
            color="secondary"
            sx={{
                height: 12,
                borderRadius: 5,
                backgroundColor: 'rgb(128 228 113 / 39%)',
                '& .MuiLinearProgress-bar': {
                    backgroundColor: '#bfe4ad',
                },
                ...sx,
            }}
        />
    );
}
